import { redirect } from '@tanstack/react-router';
import axios from 'axios';

import { getAuthentication } from '@/api/auth/authApi';
import { QueryKeys } from '@/lib/constants/query-keys';
import { resolvePath } from '@/lib/formatters/resolveEnvUrl';
import { queryClient } from '@/lib/queryClient';
import { type AuthUser } from '@/schemas/auth-user';

import { isAuthorized } from './index';

import type { PolicyName } from './types';

function isAuthenticationFailure(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false;
  const status = error.response?.status;
  return status === 401 || status === 403;
}

function redirectToLogin(): never {
  throw redirect({ href: resolvePath('home') });
}

export function requireAuthenticated() {
  return async () => {
    await queryClient
      .ensureQueryData<AuthUser>({ queryKey: [QueryKeys.AUTHENTICATION], queryFn: getAuthentication })
      .catch((error: unknown) => {
        if (isAuthenticationFailure(error)) redirectToLogin();
        throw error;
      });
  };
}

export function requireAccess(policyName: PolicyName) {
  return async () => {
    const user = await queryClient
      .ensureQueryData<AuthUser>({ queryKey: [QueryKeys.AUTHENTICATION], queryFn: getAuthentication })
      .catch((error: unknown) => {
        if (isAuthenticationFailure(error)) redirectToLogin();
        throw error;
      });

    if (!isAuthorized({ perfil: user.perfil }, policyName)) {
      return redirect({ to: '/unauthorized' });
    }
  };
}
